import React, { useEffect, useMemo } from "react";
import styles from "./ObjectOptionsItem.module.scss";
import { ObjectOptions } from "./ObjectOptions/ObjectOptions";

import { useURLRouting } from "../../../../../../utils/hooks/useURLRouting";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/store";
import {
  getProductByIdAndPath,
  getCurrentCategoryFolder,
  getProductById,
  getProductFromCache,
} from "../../../../../../redux/reducers/ui/selectors/objectSelectors";
import { RenderPreview } from "./RenderPreview/RenderPreview";
import { setActiveObjectId } from "../../../../../../redux/reducers/ui/uiReducer";
import { Variants } from "./Variants/Variants";
import { DropDownIcon } from "../../../../../../assets/svg/DropDownIcon";
import { ObjectService } from "../../../../../../services/ObjectService";

export const ObjectOptionsItem: React.FC = () => {
  const { setItem, currentView } = useURLRouting();
  const dispatch = useAppDispatch();

  const productId = currentView.list_id ?? "-1";
  const arr = productId?.split("_");
  const realProductId = parseInt(arr[0] ?? "-1");
  const projectId = parseInt(arr[1] ?? "-1");
  const pathToProject = useMemo(
    () => arr[2]?.split("#")?.map(i => parseInt(i)) ?? [],
    [arr]
  );

  const currentCategoryFolder = useAppSelector(getCurrentCategoryFolder);
  const productFromPath = useAppSelector(
    getProductByIdAndPath(realProductId, pathToProject, projectId)
  );

  // First try to get product from currentCategoryFolder (has fetched products)
  const projectInFolder = currentCategoryFolder?.projects?.find(
    p => p.id === projectId
  );
  const productFromFolder = projectInFolder?.availableProducts?.find(
    p => p.id === realProductId
  );

  // Try to get product from selectData (when object is selected from scene)
  const productFromSelectData = useAppSelector(getProductById(productId));
  const productFromCache = useAppSelector(
    getProductFromCache(projectId, realProductId)
  );

  const product =
    productFromFolder ||
    productFromSelectData ||
    productFromCache ||
    productFromPath;
  const handleBack = () => {
    setItem("");
    dispatch(setActiveObjectId(null));
  };

  useEffect(() => {
    if (!product) {
      console.log("ObjectOptionsItem: Product not found for id: ", productId);
      setItem("");
    }
  }, [product, productId, setItem]);
  if (!product) return null;

  return (
    <div className={styles.wrapper_objectItem}>
      <div className={styles.header}>
        <button onClick={handleBack}>
          <DropDownIcon /> Back
        </button>

        <div className={styles.text}>Configuration</div>

        <div className={styles.spacer}></div>
      </div>

      <div className={styles.content}>
        <RenderPreview productId={productId} />
        <Variants projectId={projectId} path={pathToProject} />
        {ObjectService.getEnabledObjectOptions(product.availableOptions).map(
          (optionGroup, idx) => (
            <ObjectOptions
              key={idx}
              productId={productId}
              type={"material"}
              optionsGroup={optionGroup}
            />
          )
        )}
        {ObjectService.getEnabledObjectOptions(
          product.availableGeometryOptions
        ).map((optionGroup, idx) => (
          <ObjectOptions
            key={idx}
            productId={productId}
            type={"geometry"}
            optionsGroup={optionGroup}
          />
        ))}
      </div>
    </div>
  );
};
